export enum DeviceSize {
  DESKTOP = 835,
  MOBILE = 414
}
